module.exports = __webpack_public_path__ + "img/edocuments.d356b90c.jpg";